import { Project, ProjectSettingsModeEnum } from '@/app/api';

export enum MixpanelEvent {
  DonationCompleted = 'purchased',
  ButtonClicked = 'button_clicked',
  Shared = 'shared',
  ChatbotEvent = 'chatbot_event',
}

export enum PageTypes {
  Checkout = 'checkout',
  ProjectDetail = 'project_detail',
}

export enum CheckoutTypes {
  OneTime = 'one-time',
  Subscription = 'subscription',
}

export enum CheckoutSteps {
  DonationForm = 'donation_form',
}

export enum CheckoutStepNumbers {
  DonationForm = 1,
}

export enum ProjectBrand {
  Plus = 'Plus',
  GoodHabit = 'Pravidelný dárce',
  Default = 'Dobro',
}

export enum GoogleTagManagerEventNames {
  BeginCheckout = 'begin_checkout',
  Purchase = 'purchase',
  ViewItem = 'view_item',
  AnalyticsLoaded = 'analytics_loaded',
}

export enum ItemCategory2 {
  LongTerm = 'long-term',
  Single = 'single',
}

export const getProjectBrand = (project: Project): ProjectBrand => {
  if (project.settings.mode === ProjectSettingsModeEnum.DonioPlus) {
    return ProjectBrand.Plus;
  }
  if (project.settings.isGoodHabit) {
    return ProjectBrand.GoodHabit;
  }

  return ProjectBrand.Default;
};

export const getProjectCategory = (project: Project): string => {
  if (project.settings.mode === ProjectSettingsModeEnum.DonioPlus) {
    return ProjectBrand.Plus;
  }
  if (project.settings.isGoodHabit) {
    return ProjectBrand.GoodHabit;
  }
  if (project.settings.taxonomy.mainCategory) {
    return project.settings.taxonomy.mainCategory.name;
  }

  return ProjectBrand.Default;
};
